import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import '../../Common/CommonStyles.css';
import MultiSelect from 'multiselect-react-dropdown';

const PartnerUserAddEditComponent = (props) => {
  //debugger;
  const { handleNewPartnerUserClose, onSubmit, selectedPartnerUser, partnerUserInfo, ActiveRoleList, accessControlMasterList, setAccessControlMasterList } = props;
  const { register, handleSubmit, formState: { errors } } = useForm();

  const [multiSelectKey, setMultiSelectKey] = useState(Date.now());

  // Force remount when accessControlMasterList changes or when we need to clear
  const forceMultiSelectReset = () => {
    setMultiSelectKey(Date.now());
  };

  // const handleMappingDelete = (Access_Control_Id) => {
  //   //debugger;
  //   const updatedList = accessControlMasterList.map(item =>
  //     item.Access_Control_Id === Access_Control_Id
  //       ? { ...item, IsDeleted: true, IsSelected: false, UserId: selectedPartnerUser?.UserId }
  //       : item
  //   );
  //   setAccessControlMasterList(updatedList);
  // }

  const handleMappingDelete = (Access_Control_Id) => {
    //debugger;

    // Find the item being deleted
    const itemToDelete = accessControlMasterList.find(item =>
      item.Access_Control_Id === Access_Control_Id
    );

    if (!itemToDelete) return;

    // Check if any currently selected items depend on the item being deleted
    const dependentItems = accessControlMasterList.filter(item =>
      item.IsSelected === true &&
      item.Access_Control_Id !== Access_Control_Id && // Not the item being deleted
      item.Is_Dependency === true &&
      item.DependencyParam &&
      item.DependencyParam.split(',').map(name => name.trim()).includes(itemToDelete.Access_Control_Name)
    );

    if (dependentItems.length > 0) {
      let dependencyNames;

      // Check if removing this item would leave any dependent item without dependencies
      const itemsWithUnmetDependencies = dependentItems.filter(dependentItem => {
        dependencyNames = dependentItem.DependencyParam.split(',').map(name => name.trim());

        // Check if after deletion, at least one dependency would still be met
        const wouldDependenciesBeMetAfterDeletion = dependencyNames.some(depName =>
          accessControlMasterList.some(item =>
            item.Access_Control_Name === depName &&
            item.IsSelected === true &&
            item.Access_Control_Id !== Access_Control_Id // Exclude the item being deleted
          )
        );

        return !wouldDependenciesBeMetAfterDeletion;
      });

      if (itemsWithUnmetDependencies.length > 0) {
        const unmetDependencyNames = itemsWithUnmetDependencies.map(item => item.Access_Control_Name).join(', ');
        alert(`At least one from ( ${dependencyNames} ) must remain selected to retain ${unmetDependencyNames}`);
        forceMultiSelectReset();
        return;
      }
    }

    // Proceed with deletion
    const updatedList = accessControlMasterList.map(item =>
      item.Access_Control_Id === Access_Control_Id
        ? { ...item, IsDeleted: true, IsSelected: false, UserId: selectedPartnerUser?.UserId }
        : item
    );
    setAccessControlMasterList(updatedList);
  }

  const handleMappingInsert = (data) => {
    //debugger;

    // Check if dependencies need to be validated
    if (data.Is_Dependency === true && data.DependencyParam) {
      // Split the comma-separated dependency parameters
      const dependencyNames = data.DependencyParam.split(',').map(name => name.trim());

      // Check if at least one dependency is selected
      const isDependencyMet = dependencyNames.some(depName =>
        accessControlMasterList.some(item =>
          item.Access_Control_Name === depName && item.IsSelected === true
        )
      );

      // Find Access_Control_Names from accessControlMasterList where Is_Dependency === true 
      // and their DependencyParam includes any of the dependencyNames
      const dependentAccessControlNames = accessControlMasterList
        .filter(item => 
          item.Is_Dependency === true && 
          item.DependencyParam &&
          dependencyNames.some(depName => 
            item.DependencyParam.split(',').map(name => name.trim()).includes(depName)
          )
        )
        .map(item => item.Access_Control_Name);

      // If dependency is not met
      if (!isDependencyMet) {
        alert(`${dependentAccessControlNames} requires selecting ${dependencyNames.join(', ')} first`);
        forceMultiSelectReset()
        return;
      }
    }

    // Original logic - proceed with selection
    const updatedList = accessControlMasterList.map(item =>
      item.Access_Control_Id === data.Access_Control_Id
        ? { ...item, IsSelected: true, IsDeleted: false, UserId: selectedPartnerUser?.UserId }
        : item
    );
    setAccessControlMasterList(updatedList);
  };

  return (
    <>
      <div className="modal-backdrop">
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg custom-modal" style={{ maxWidth: '700px' }} role="document">
            <div className="modal-content mb-0 p-0">
              <div className="modal-header p-2-5">
                <h5 className="modal-title">{selectedPartnerUser.UserId ? "Edit User" : "New Staff"}</h5>
                <button type="button" className="btn-close" onClick={handleNewPartnerUserClose}></button>
              </div>
              <div className="modal-body p-1">
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                  <div className="container mb-0" style={{ fontSize: "13px" }}>

                    <div className="row">
                      <input type="text" hidden className="form-control" {...register("UserId")} defaultValue={selectedPartnerUser?.UserId || null} />
                      <div className="col-md-6 mb-2">
                        <label className="fw-bold required mb-0-5">First Name</label>
                        <input type="text" className="form-control" placeholder="Enter First Name" {...register("FirstName", { required: "First Name is required" })} defaultValue={selectedPartnerUser?.FirstName || ""} />
                        {errors.FirstName && <p className="text-danger required_error">{errors.FirstName.message}</p>}
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="fw-bold required mb-0-5">Last Name</label>
                        <input type="text" className="form-control" placeholder="Enter Last Name" {...register("LastName", { required: "Last Name is required" })} defaultValue={selectedPartnerUser?.LastName || ""} />
                        {errors.LastName && <p className="text-danger required_error">{errors.LastName.message}</p>}
                      </div>


                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <div className="row">
                          <div className="col-8">
                            <label className="fw-bold required mb-0-5">Mobile No</label>
                            <input type="text" placeholder="Enter Mobile No" className="form-control" defaultValue={selectedPartnerUser?.MobileNo || ""}  {...register("MobileNo", {
                              required: "Customer Mobile is required", pattern: { value: /^[0-9]+$/, message: "Only numbers are allowed", },
                              minLength: { value: 10, message: "Mobile number must be at least 10 digits", },
                              maxLength: { value: 10, message: "Mobile number must not exceed 10 digits", },
                            })}
                              onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))} />
                            {errors.MobileNo && (
                              <p className="text-danger required_error">
                                {errors.MobileNo.message}
                              </p>
                            )}
                          </div>
                          <div className="col-4" style={{ marginTop: '20px' }}>
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" {...register("IsOtp")} defaultChecked={selectedPartnerUser?.IsOtp || false} />
                              <label className="form-check-label fw-bold">Is Otp</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="fw-bold required mb-0-5">Email Id</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email Id"
                          defaultValue={selectedPartnerUser?.EmailId || ""}
                          {...register("EmailId", {
                            required: "Email Id is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Invalid email address",
                            },
                          })}
                        />
                        {errors.EmailId && <p className="text-danger required_error">{errors.EmailId.message}</p>}
                      </div>
                    </div>

                    <div className="row">
                      {partnerUserInfo?.partnerUserData?.Role_Name === "Admin" && (
                        <div className="col-md-6 mb-2">
                          <label className="fw-bold mb-0-5">Password</label>
                          <input type="password" className="form-control" disabled placeholder={selectedPartnerUser?.UserId ? "" : "Auto generate password"} {...register("Password")} defaultValue={selectedPartnerUser?.Password || ""} />
                          {errors.Password && <p className="text-danger required_error">{errors.Password.message}</p>}
                        </div>
                      )}
                      <div className="col-md-6 mb-2">
                        <label className="fw-bold required mb-0-5">Role</label>
                        <select className="form-select" {...register("RoleId", { required: "Role is required" })} defaultValue={selectedPartnerUser?.RoleId || ""}>
                          <option value="">Select Role</option>
                          {ActiveRoleList.map((item) => (
                            <option key={item.Role_Id} value={item.Role_Id}>
                              {item.Role_Name}
                            </option>
                          ))}
                        </select>
                        {errors.RoleId && <p className="text-danger required_error">{errors.RoleId.message}</p>}
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="fw-bold mb-0-5">Emp Code</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Emp Code"
                          {...register("Emp_Code", {
                            maxLength: {
                              value: 30,
                              message: "Emp Code cannot exceed 30 characters",
                            },
                          })}
                          defaultValue={selectedPartnerUser?.Emp_Code || ""}
                        />
                        {errors.Emp_Code && <p className="text-danger required_error">{errors.Emp_Code.message}</p>}
                      </div>

                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <label className="fw-bold mb-0-5">User Access</label>
                        <MultiSelect
                          key={multiSelectKey}
                          options={accessControlMasterList}
                          selectedValues={accessControlMasterList.filter(access => access.IsSelected)}
                          displayValue="Access_Control_Name"
                          onSelect={(selectedList, selectedItem) => handleMappingInsert(selectedItem)}
                          onRemove={(selectedList, removedItem) => handleMappingDelete(removedItem.Access_Control_Id)}
                          placeholder="Select Allowed Access"
                        />
                        {/* {errors.Emp_Code && <p className="text-danger required_error">{errors.Emp_Code.message}</p>} */}
                      </div>
                      <input type="hidden" className="form-control" placeholder="Enter Partner Code" {...register("Partner_Code")} defaultValue={selectedPartnerUser?.Partner_Code || ""} />
                    </div>

                  </div>

                  <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                    <button type="button" className="btn btn-danger" onClick={handleNewPartnerUserClose}>Close</button>
                    <button type="submit" className="btn custom-sumbitbtn">{selectedPartnerUser?.UserId ? "Update" : "Save"}</button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default PartnerUserAddEditComponent